import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from'vant';
import 'vant/lib/index.css';
import '@/assets/scss/index.scss'

Vue.config.productionTip = false
Vue.use(Vant);


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
